export default function runSearchQuery(context, input) {
    const { service } = context;

    const { options = {} } = input;

    service.runSearchQuery({
        options,
    });
}
